module.exports = __webpack_public_path__ + "media/corrin.d60479d3.wav";